import {useSelector} from 'react-redux';

import BadgesGrid from '@/components/BadgesGrid/BadgesGrid';
import {selectAllBadges} from '@/state/selectors/loyalty';

const BadgesCollectionSection = () => {
    const badges = useSelector(selectAllBadges);

    if (!badges.length) return null;

    return <BadgesGrid badges={badges} />;
};

export default BadgesCollectionSection;
